import { Cookies } from '@tencent/ovb-utils';
export default {
    /**
     * 设置一个cookie
     * @param name cookie名称
     * @param value cookie值
     * @param domain 所在域名 默认为window.location.host的值
     * @param path 所在路径 默认为是"\"
     * @param hour 存活时间，单位:小时
     */
    set: function (name, value, domain, path, hour) {
        var param = {
            domain: domain,
            path: path,
        };
        if (hour) {
            param.expires = new Date().getTime() + (hour * 3600 * 1e3);
        }
        Cookies.setCookie(name, value, param);
        return true;
    },
    /**
     * 获取指定名称的cookie值
     * @param name cookie名称
     * @return 获取到的cookie值
     */
    get: function (name) {
        return Cookies.getCookie(name) || '';
    },
    /**
     * 删除指定cookie,复写为过期
     * @param name cookie名称
     * @param domain 所在域 默认为 window.location.host的值
     * @param path 所在路径 默认为是"\"
     */
    del: Cookies.clearCookie,
};
